import { RootState } from "@/store/Store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface CountriesStateInterface {
    formVisible: boolean,
    formVariant: "new" | "edit",
}

function getInitialState(): CountriesStateInterface {
    return {
        formVisible: false,
        formVariant: "new",
    }
}

export const CountriesSlice = createSlice({
    name: "CountriesSlice",
    initialState: getInitialState(),
    reducers: {
        changeFormVisibility: (state: CountriesStateInterface, action: PayloadAction<CountriesStateInterface["formVisible"]>) => {
            state.formVisible = action.payload;
        },
        changeFormVariant: (state: CountriesStateInterface, action: PayloadAction<CountriesStateInterface["formVariant"]>) => {
            state.formVariant = action.payload;
        },
        reset: (state: CountriesStateInterface, action: PayloadAction<void>) => {
            const initialState = getInitialState();
            state.formVisible = initialState.formVisible;
            state.formVariant = initialState.formVariant;
        },
    },
});

export const {
    changeFormVisibility,
    changeFormVariant,
    reset,
} = CountriesSlice.actions;

export const getSelectorForValue = (name: keyof CountriesStateInterface) => (state: RootState) => state.countries[name];

export const CountriesReducer = CountriesSlice.reducer;
